import FormSettingsForm from '@staticsnap/dashboard/components/form-settings/form-settings';

export default function FormsIndex() {
  return <FormSettingsForm title="Form Settings" />;
}
